// Copyright 2026 Bitech.id. Licensed under the MIT License.

export function generateEventId(): string {
  const webCrypto = globalThis.crypto;
  if (webCrypto && typeof webCrypto.randomUUID === 'function') {
    return webCrypto.randomUUID();
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = Math.floor(Math.random() * 16);
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

let _spanCounter = 0;

export function generateTraceId(): string {
  const hex = '0123456789abcdef';
  let id = '';
  for (let i = 0; i < 32; i++) id += hex[Math.floor(Math.random() * 16)];
  return id;
}

export function generateSpanId(): string {
  const hex = '0123456789abcdef';
  let id = '';
  const ts = Date.now().toString(16).slice(-8);
  for (let i = 0; i < 8; i++) id += hex[Math.floor(Math.random() * 16)];
  id += ts;
  _spanCounter = (_spanCounter + 1) & 0xffff;
  id += _spanCounter.toString(16).padStart(4, '0');
  return id.slice(0, 16);
}
